export default __webpack_public_path__ + "static/media/header_bg_new.44014378.png";